import React, { useState, useEffect } from "react";
import Lista from "./lista";
import Video from "../Video/video";
import Contact from "../Contact/contact";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import School from "@mui/icons-material/School";
import LinearProgress from "@mui/material/LinearProgress";
import {
  obtenerPlayList,
  obtenerLastVideos,
} from "../Services/youtubeServices";

const Listas = () => {
  const [listas, setListas] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    cargarPlayList();
  }, []);

  const cargarPlayList = async () => {
    const { data: listas } = await obtenerPlayList();
    setListas(listas.items);
    const { data: videos } = await obtenerLastVideos();
    setVideos(videos.items);
    //console.log(videos);
    setLoading(false);
    //console.log(listas);
  };

  return (
    <>
      {loading && <LinearProgress />}

      <div className="main-bg7">
        <div className="main-title5">
          <h1>
            VIDEOS RECIENTES
            <SlowMotionVideoIcon
              sx={{ fontSize: 70, color: "#FFF", verticalAlign: "middle" }}
            />
          </h1>
        </div>
      </div>

      <Container disableGutters sx={{ p: 2, backgroundColor: "white" }}>
        <section>
          <h3 style={{ textAlign: "center" }}>VIDEOS</h3>
          <Grid container spacing={2}>
            {videos.map((video, index) => (
              <Video video={video} key={index}></Video>
            ))}
          </Grid>
          <h3 style={{ textAlign: "center" }}>LISTAS DE REPRODUCCIÓN</h3>
          <Grid container spacing={2}>
            {listas.map((lista) => (
              <Lista lista={lista} key={lista.id}></Lista>
            ))}
          </Grid>
        </section>
      </Container>
      <Contact />
    </>
  );
};

export default Listas;
